const paymentMethodsKeys = {
  module: ['paymentMethods'] as const,
  list: () => [...paymentMethodsKeys.module, 'list'] as const,
  listWithFilters: (filters: any) =>
    [...paymentMethodsKeys.list(), filters] as const,
  details: (id: string) =>
    [...paymentMethodsKeys.module, 'details', id] as const,
};

export default paymentMethodsKeys;
